<!-- Loading Screen -->
<ng-container *ngIf="isLoading$ | async">
  <div class="backdrop">
    <img src="../../assets/images/three-dots.svg" />
  </div>
</ng-container>

<router-outlet></router-outlet>